import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './i18n';
import './index.css';
import App from './App.tsx';
import Login from './pages/Login.tsx';
import Account from './pages/Account.tsx';
import Admin from './pages/Admin.tsx';
import { TRPCProvider } from './providers/trpc';

createRoot(document.getElementById('root')!).render(
  <TRPCProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/login" element={<Login />} />
        <Route path="/account" element={<Account />} />
        {/* Admin console — login + password gate (no Telegram identity used).
            URL is intentionally non-obvious and never linked anywhere in the
            UI. A stranger who guesses the path sees a 404 mask because every
            server query rejects them. */}
        <Route path="/sys/console" element={<Admin />} />
        {/* Any other unknown URL (incl. typos / accidental %20) → home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </TRPCProvider>
);
